// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"transitionDefault_paragraph__1D5eH","highlight":"transitionDefault_highlight__2rxLy","btn":"transitionDefault_btn__IK0g3"};